export const selectAdminAuthState = (state) => state.adminAuth;
export const selectAdminAuthData = (state) => state.adminAuth.data;
export const selectAdminAuthIsLogin = (state) => state.adminAuth.isLogin;
